export default __webpack_public_path__ + "static/media/Cucumber Seeds.d18be6af.PNG";